module.exports = __webpack_public_path__ + "img/ic_home_appgallery.cd5e852b.png";